// FCM push registration for the native app. Fully no-ops on web or if the
// @capacitor/push-notifications plugin isn't installed yet — so it's safe to ship
// before Firebase is wired up. Once the plugin + google-services.json are in place,
// this registers the device token with the server so reminders arrive as real pushes.
import { Capacitor } from '@capacitor/core'
import { API_BASE } from '../config'

let PushNotifications = null
try { PushNotifications = require('@capacitor/push-notifications').PushNotifications } catch (e) {}

let _wired = false

export async function registerPush(authToken) {
  if (!Capacitor.isNativePlatform() || !PushNotifications || !authToken) return
  try {
    let perm = await PushNotifications.checkPermissions()
    if (perm.receive === 'prompt' || perm.receive === 'prompt-with-rationale') perm = await PushNotifications.requestPermissions()
    if (perm.receive !== 'granted') return

    // Channel must match the server's android.notification.channelId ('medicine-reminders')
    try { await PushNotifications.createChannel({ id: 'medicine-reminders', name: 'Medicine Reminders', description: 'Dose reminders', importance: 5, visibility: 1 }) } catch (e) {}

    if (!_wired) {
      _wired = true
      PushNotifications.addListener('registration', async (t) => {
        try {
          await fetch(API_BASE + '/api/push/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authToken}` },
            body: JSON.stringify({ token: t.value, platform: 'android' }),
          })
        } catch (e) {}
      })
      PushNotifications.addListener('registrationError', (e) => console.warn('[push] registration error', e))
    }

    await PushNotifications.register()
  } catch (e) { console.warn('[push] registerPush failed:', e && e.message) }
}
